import _defineProperty from '@babel/runtime/helpers/defineProperty';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var MarginPropsMapping = {
  /**
   * Shorthand for `margin`
   */
  m: 'margin',
  /**
   * Sets `margin` CSS property
   */
  margin: 'margin',
  /**
   * Shorthand for `marginLeft`
   */
  ml: 'margin-left',
  /**
   * Sets `margin-left` CSS property
   */
  marginLeft: 'margin-left',
  /**
   * Shorthand for `marginBottom`
   */
  mb: 'margin-bottom',
  /**
   * Sets `margin-bottom` CSS property
   */
  marginBottom: 'margin-bottom',
  /**
   * Shorthand for `marginTop`
   */
  mt: 'margin-top',
  /**
   * Sets `margin-top` CSS property
   */
  marginTop: 'margin-top',
  /**
   * Shorthand for `marginRight`
   */
  mr: 'margin-right',
  /**
   * Sets `margin-right` CSS property
   */
  marginRight: 'margin-right',
  /**
   * Shorthand for `marginHorizontal`
   */
  mh: ['margin-left', 'margin-right'],
  /**
   * Sets `margin-left` and `margin-right` CSS properties
   */
  marginHorizontal: ['margin-left', 'margin-right'],
  /**
   * Shorthand for `marginTop` and `marginBottom`
   */
  mv: ['margin-top', 'margin-bottom'],
  /**
   * Sets `margin-top` and `margin-bottom` CSS properties
   */
  marginVertical: ['margin-top', 'margin-bottom']
};
var PaddingPropsMapping = {
  /**
   * Shorthand for `padding`
   */
  p: 'padding',
  /**
   * Sets `padding` CSS property
   */
  padding: 'padding',
  /**
   * Shorthand for `paddingLeft`
   */
  pl: 'padding-left',
  /**
   * Sets `padding-left` CSS property
   */
  paddingLeft: 'padding-left',
  /**
   * Shorthand for `paddingBottom`
   */
  pb: 'padding-bottom',
  /**
   * Sets `padding-bottom` CSS property
   */
  paddingBottom: 'padding-bottom',
  /**
   * Shorthand for `paddingTop`
   */
  pt: 'padding-top',
  /**
   * Sets `padding-top` CSS property
   */
  paddingTop: 'padding-top',
  /**
   * Shorthand for `paddingRight`
   */
  pr: 'padding-right',
  /**
   * Sets `padding-right` CSS property
   */
  paddingRight: 'padding-right',
  /**
   * Shorthand for `paddingLeft` and `paddingRight`
   */
  ph: ['padding-left', 'padding-right'],
  /**
   * Sets `padding-left` and `padding-right` CSS properties
   */
  paddingHorizontal: ['padding-left', 'padding-right'],
  /**
   * Shorthand for `paddingTop` and `paddingBottom`
   */
  pv: ['padding-top', 'padding-bottom'],
  /**
   * Sets `padding-top` and `padding-bottom` CSS properties
   */
  paddingVertical: ['padding-top', 'padding-bottom']
};
var FlexContainerPropsMapping = {
  /**
   * Sets `display` CSS property
   */
  display: 'display',
  /**
   * Sets `align-content` CSS property
   */
  alignContent: 'align-content',
  /**
   * Sets `align-items` CSS property
   */
  alignItems: 'align-items',
  /**
   * Sets `flex-direction` CSS property
   */
  flexDirection: 'flex-direction',
  /**
   * Sets `justify-content` CSS property
   */
  justifyContent: 'justify-content'
};
var FlexItemPropsMapping = {
  /**
   * Sets `align-self` CSS property
   */
  alignSelf: 'align-self',
  /**
   * Sets `flex` CSS property
   */
  flex: 'flex',
  /**
   * Sets `flex-grow` CSS property
   */
  flexGrow: 'flex-grow',
  /**
   * Sets `flex-shrink` CSS property
   */
  flexShrink: 'flex-shrink',
  /**
   * Sets `flex-wrap` CSS property
   */
  flexWrap: 'flex-wrap',
  /**
   * Sets `flex-basis` CSS property
   */
  flexBasis: 'flex-basis',
  /**
   * Sets `order` CSS property
   */
  order: 'order',
  /**
   * Sets `visibility` CSS property
   */
  visibility: 'visibility'
};
var GridPropsMapping = {
  /**
   * Sets `column-gap` CSS property
   */
  columnGap: 'column-gap',
  /**
   * Sets `grid-area` CSS property
   */
  gridArea: 'grid-area',
  /**
   * Sets `gap` CSS property
   */
  gap: 'gap',
  /**
   * Sets `grid-auto-flow` CSS property
   */
  gridAutoFlow: 'grid-auto-flow',
  /**
   * Sets `grid-template-columns` CSS property
   */
  gridTemplateColumns: 'grid-template-columns',
  /**
   * Sets `grid-template-rows` CSS property
   */
  gridTemplateRows: 'grid-template-rows',
  /**
   * Sets `grid-row` CSS property
   */
  gridRow: 'grid-row',
  /**
   * Sets `grid-column` CSS property
   */
  gridColumn: 'grid-column',
  /**
   * Sets `justify-self` CSS property
   */
  justifySelf: 'justify-self',
  /**
   * Sets `row-gap` CSS property
   */
  rowGap: 'row-gap'
};
var ColorPropsMapping = {
  /**
   * Sets `background-color` CSS property
   */
  backgroundColor: 'background-color',
  /**
   * Sets `background` CSS property
   */
  background: 'background',
  /**
   * Sets `color` CSS property
   */
  textColor: 'color',
  /**
   * Sets `opacity` CSS property
   */
  opacity: 'opacity'
};
var BorderPropsMapping = {
  /**
   * Shorthand for `border`
   */
  b: 'border',
  /**
   * Sets `border` CSS property
   */
  border: 'border',
  /**
   * Shorthand for `borderLeft`
   */
  bl: 'border-left',
  /**
   * Sets `border-left` CSS property
   */
  borderLeft: 'border-left',
  /**
   * Shorthand for `borderBottom`
   */
  bb: 'border-bottom',
  /**
   * Sets `border-bottom` CSS property
   */
  borderBottom: 'border-bottom',
  /**
   * Shorthand for `borderTop`
   */
  bt: 'border-top',
  /**
   * Sets `border-top` CSS property
   */
  borderTop: 'border-top',
  /**
   * Shorthand for `borderRight`
   */
  br: 'border-right',
  /**
   * Sets `border-right` CSS property
   */
  borderRight: 'border-right',
  /**
   * Shorthand for `borderLeft` and `borderRight` CSS properties
   */
  bh: ['border-left', 'border-right'],
  /**
   * Sets `border-left` and `border-right` CSS properties
   */
  borderHorizontal: ['border-left', 'border-right'],
  /**
   * Shorthand for `borderTop` and `borderBottom` CSS properties
   */
  bv: ['border-top', 'border-bottom'],
  /**
   * Sets `border-top` and `border-bottom` CSS properties
   */
  borderVertical: ['border-top', 'border-bottom'],
  /**
   * Sets `border-color` CSS property
   */
  borderColor: 'border-color',
  /**
   * Sets `border-width` CSS property
   */
  borderWidth: 'border-width',
  /**
   * Sets `border-radius` CSS property
   */
  borderRadius: 'border-radius'
};
var ShadowPropsMapping = {
  /**
   * Sets `box-shadow` CSS property
   */
  boxShadow: 'box-shadow'
};
var SizePropsMapping = {
  /**
   * Sets `box-sizing` CSS property
   */
  boxSizing: 'box-sizing',
  /**
   * Sets `height` CSS property
   */
  height: 'height',
  /**
   * Sets `min-height` CSS property
   */
  minHeight: 'min-height',
  /**
   * Sets `max-height` CSS property
   */
  maxHeight: 'max-height',
  /**
   * Sets `width` CSS property
   */
  width: 'width',
  /**
   * Sets `min-width` CSS property
   */
  minWidth: 'min-width',
  /**
   * Sets `max-width` CSS property
   */
  maxWidth: 'max-width',
  /**
   * Sets `object-fit` CSS property
   */
  objectFit: 'object-fit',
  /**
   * Sets the `aspect-ratio` CSS property
   */
  aspectRatio: 'aspect-ratio'
};
var TransitionPropsMapping = {
  /**
   * Sets `transition` CSS property
   */
  transition: 'transition',
  /**
   * Sets `transition-delay` CSS property
   */
  transitionDelay: 'transition-delay',
  /**
   * Sets `transition-duration` CSS property
   */
  transitionDuration: 'transition-duration',
  /**
   * Sets `transition-property` CSS property
   */
  transitionProperty: 'transition-property',
  /**
   * Sets `transition-timing-function` CSS property
   */
  transitionTimingFunction: 'transition-timing-function'
};
var TextPropsMapping = {
  /**
   * Sets `text-align` CSS property
   */
  textAlign: 'text-align',
  /**
   * Sets the `text-transform` CSS propert
   */
  textTransform: 'text-transform',
  /**
   * Sets `font-family` CSS property
   */
  fontFamily: 'font-family',
  /**
   * Sets `font-size` CSS property
   */
  fontSize: 'font-size',
  /**
   * Sets `font-weight` CSS property
   */
  fontWeight: 'font-weight',
  /**
   * Sets `line-height` CSS property
   */
  lineHeight: 'line-height',
  /**
   * Sets `vertical-align` CSS property
   */
  verticalAlign: 'vertical-align',
  /**
   * Sets `text-wrap` CSS property
   */
  textWrap: 'text-wrap'
};
var PositionPropsMapping = {
  /**
   * Sets `position` CSS property
   */
  position: 'position',
  /**
   * Sets `inset` CSS property
   */
  inset: 'inset',
  /**
   * Sets `left` CSS property
   */
  left: 'left',
  /**
   * Sets `bottom` CSS property
   */
  bottom: 'bottom',
  /**
   * Sets `top` CSS property
   */
  top: 'top',
  /**
   * Sets `right` CSS property
   */
  right: 'right',
  /**
   * Sets `z-index` CSS property
   */
  zIndex: 'z-index',
  /**
   * Sets `transform` CSS property
   */
  transform: 'transform'
};
var OverflowPropsMapping = {
  /**
   * Sets `overflow` CSS property
   */
  overflow: 'overflow',
  /**
   * Sets `overflow-x` CSS property
   */
  overflowX: 'overflow-x',
  /**
   * Sets `overflow-y` CSS property
   */
  overflowY: 'overflow-y',
  /**
   * Sets `text-overflow` CSS property
   */
  textOverflow: 'text-overflow',
  /**
   * Sets `white-space` CSS property
   */
  whiteSpace: 'white-space'
};
var CursorPropMapping = {
  /**
   * Sets the `cursor` CSS property
   */
  cursor: 'cursor'
};
var ScrollPropsMapping = {
  /**
   * Sets the `scroll-margin` CSS property
   */
  scrollMargin: 'scroll-margin'
};
var BoxPropsMapping = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, MarginPropsMapping), PaddingPropsMapping), FlexContainerPropsMapping), FlexItemPropsMapping), GridPropsMapping), ColorPropsMapping), BorderPropsMapping), ShadowPropsMapping), SizePropsMapping), TransitionPropsMapping), TextPropsMapping), PositionPropsMapping), OverflowPropsMapping), ScrollPropsMapping), CursorPropMapping);
var boxPropExclusions = new Set(Object.keys(BoxPropsMapping));

export { BorderPropsMapping, BoxPropsMapping, ColorPropsMapping, CursorPropMapping, FlexContainerPropsMapping, FlexItemPropsMapping, GridPropsMapping, MarginPropsMapping, OverflowPropsMapping, PaddingPropsMapping, PositionPropsMapping, ScrollPropsMapping, ShadowPropsMapping, SizePropsMapping, TextPropsMapping, TransitionPropsMapping, boxPropExclusions };
